


export default {
    namespaced: true,
    state: () => ({

        pofilters:{
            pono:'',
            postatus:'',
            location_id:'',
            supplier_id:'',
            sku:'',
            page:1,

        },
        selected_poprint:null

    }),
    mutations: {



        setselected_poprint(state,data){
            state.selected_poprint=data
        },



    },
    actions: {




        add_selected_poprint({commit},selected_poprint){
            commit('setselected_poprint', selected_poprint)
        },

    },


}
